import { requestJson } from "./instateamEmployeeApi";

export function getEmployeeDashboard(token) {
  return requestJson("/instateam/dashboard/employee", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function createEmployeeQuickNote(token, payload) {
  return requestJson("/instateam/dashboard/employee/quick-notes", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

export function deleteEmployeeQuickNote(token, noteId) {
  return requestJson(`/instateam/dashboard/employee/quick-notes/${noteId}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
